import classNames from 'classnames';
import { useState } from 'react';
import { useDebounce } from 'react-use';

import { LinkPreview } from 'components/settings/components/sections/dixaMessenger/views/flow/components/shared/knowledgeBaseLinkPreview/components/LinkPreview';

import { useElevioIntegration } from '../../../elevioIntegrationProvider';

import styles from './styles.module.scss';
import { parseElevioArticleUrls } from './utils/parseElevioLinks';

export type LinkPreviewProps = {
  headline: string;
  description: string;
  to: string;
  className?: string;
};

type Props = {
  className?: string;
  text: string;
};

export function KnowledgeBaseLinkPreview({
  text,
  className,
}: Props): JSX.Element | null {
  const [debouncedArticleUrls, setDebouncedArticleUrls] = useState<string[]>(
    [],
  );

  const { elevioIntegration } = useElevioIntegration();

  useDebounce(
    () => {
      if (!elevioIntegration?.kbLink) return;

      setDebouncedArticleUrls(
        parseElevioArticleUrls(text, elevioIntegration.kbLink),
      );
    },
    1000,
    [text, elevioIntegration?.kbLink],
  );

  if (debouncedArticleUrls.length === 0) {
    return null;
  }

  return (
    <div className={classNames(styles.listContainer, className)}>
      {debouncedArticleUrls.map((articleUrl) => (
        <LinkPreview key={articleUrl} articleUrl={articleUrl} />
      ))}
    </div>
  );
}
